<template>
    <div>
        <ob1-popin-modal2
            :id="modalId"
            :aria-labelledby="modalId+'-details'"
            :show-close-button="!recoverySimulator || !simulatorModalId"
        >
            <h3 class="h4 my-1">
                {{ infosRecovery.title }}
            </h3>
            <ob1-message-complementaire
                v-if="bonusAmount"
                class="text-mw mb-2"
                :title="bonusAmount + infosRecovery.message"
            />
            <ul class="list-unstyled mb-0">
                <li class="text-mw mb-1">
                    <div class="items-list-item highlight">
                        <span class="item-icon" :class="infosRecovery.stepOne.icon" aria-hidden="true" />
                        <p class="mb-0" v-html="infosRecovery.stepOne.text" />
                    </div>
                </li>
                <li class="text-mw">
                    <div class="items-list-item highlight">
                        <span class="item-icon" :class="infosRecovery.stepTwo.icon" aria-hidden="true" />
                        <p class="mb-0" v-html="infosRecovery.stepTwo.text" />
                    </div>
                    <AlertMessage
                        class="mt-1"
                        type="warning"
                        is-mini
                        :title="infosRecovery.warningMessage"
                        :bold-title="false"
                    />
                    <ul class="list-unstyled mt-1">
                        <li
                            v-for="(item, index) in infosRecovery.processDetails"
                            :key="'process-item-'+index"
                            class="text-mw"
                            :class="index === infosRecovery.processDetails.length - 1 ? '' : 'mb-1'"
                        >
                            <div class="items-list-item highlight">
                                <span class="item-icon" :class="item.icon" aria-hidden="true" />
                                <p class="mb-0" v-html="item.text" />
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>
            <AlertMessage
                v-if="recoverySimulator.bonASavoirText"
                :title="recoverySimulator.bonASavoirText"
                :no-background="true"
                :bold-title="false"
            />
            <ob1-liens-haut-bas
                :button-id="'recovery-more-button'"
                :button-label="moreLabel"
                :collapsed-block-id="'recovery-more-infos'"
                :is-collapsed="true"
            >
                <recovery-details-part
                    v-if="onlineRecovery"
                    class="mb-1"
                    :recovery-details="onlineRecovery"
                />
                <recovery-details-part
                    v-if="storeRecovery"
                    :recovery-details="storeRecovery"
                />
                <template v-if="bonus">
                    <h4 class="mt-1">
                        {{ bonusRecovery.title }}
                    </h4>
                    <recovery-bonus-part
                        :bonus-details="bonusRecovery"
                        :condition="bonus.condition"
                    />
                </template>
            </ob1-liens-haut-bas>
            <div
                v-if="recoverySimulator && simulatorModalId"
                class="modal-footer mt-2"
            >
                <ob1-boutons
                    :is-primary="true"
                    :label="simulatorButtonLabel"
                    data-bs-toggle="modal"
                    :data-bs-target="'#' + simulatorModalId"
                    data-oevent-label="estimer_votre_mobile_actuel"
                    data-oevent-action="j_accede_au_simulateur"
                    data-oevent-category="estimer_votre_appareil_depuis_la_popin_de_reprise"
                />
            </div>
        </ob1-popin-modal2>
    </div>
</template>

<script>
import AlertMessage from "../../common/components/ob1/AlertMessage.vue";
import RecoveryBonusPart from "./RecoveryBonusPart.vue";
import RecoveryDetailsPart from "./RecoveryDetailsPart.vue";

export default {
    name: "MobileRecoveryDetailsModal",
    components: {AlertMessage, RecoveryBonusPart, RecoveryDetailsPart},
    props: {
        modalId: {
            type: String,
            required: true
        },
        infosRecovery: {
            type: Object,
            required: true
        },
        onlineRecovery: {
            type: Object,
            default: undefined
        },
        storeRecovery: {
            type: Object,
            default: undefined
        },
        bonusRecovery: {
            type: Object,
            required: true
        },
        bonus: {
            type: Object,
            default: undefined
        },
        recoverySimulator: {
            type: Object,
            default: null
        },
        simulatorButtonLabel: {
            type: String,
            required: true
        },
        bonusAmount: {
            type: String,
            default: null
        },
        simulatorModalId: {
            type: String,
            default: null
        }
    },
    computed: {
        moreLabel: function() {
            return this.bonus ? this.infosRecovery.moreWithBonus : this.infosRecovery.moreWithoutBonus;
        }
    }
};
</script>

<style lang="scss" scoped>
@import 'ob1_common';

.items-list-item {
    max-width: inherit;
    align-items: inherit;

    .item-icon {
        font-size: px-to-rem(24);
        padding-top: px-to-rem(8);
    }
}

</style>
